
export enum ErrorCodes {
    EmailNotVerified = "EmailNotVerified"
}